import Auth0StrategyProvider from './Auth0StrategyProvider';
import LoginComponent from './LoginComponent';
import LogoutComponent from './LogoutComponent';
import { auth0CoreStrategy } from './CoreStrategy';
import { Auth0Config } from './Config';

const auth0Strategy = {
  ...auth0CoreStrategy,
  ...Auth0Config,
  AuthProvider: Auth0StrategyProvider,
  LoginComponent,
  LogoutComponent,
};

export { auth0Strategy };
